require('./paginationButtons.scss');

//@Vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

//@Commons
const { scrollToTop } = require('commonsUtilities/scrollUtils');

//@utilities
const { formatWithoutRound } = require('utilities/currencyHelper');

class PaginationButtons extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            group: 1
        };

        this.goToFirstPosition = this.goToFirstPosition.bind(this);
        this.goToLastPosition = this.goToLastPosition.bind(this);
        this.goToNextPosition = this.goToNextPosition.bind(this);
        this.goToPreviousPosition = this.goToPreviousPosition.bind(this);
        this.callbackFunctionWithPage = this.callbackFunctionWithPage.bind(this);
    }

    callbackFunctionWithPage(numberPage) {
        this.props.callbackFunction(numberPage);
        scrollToTop();
    }

    goToFirstPosition(firstPage) {
        if(!firstPage) {
            this.callbackFunctionWithPage(1);
        }
    }

    goToLastPosition(lastPage) {
        if(!lastPage) {
            this.callbackFunctionWithPage(this.props.totalPages);
        }
    }

    goToNextPosition(lastPage) {
        if(!lastPage) {
            const nextPage = this.props.pageNumber + 1;
            this.callbackFunctionWithPage(nextPage);
        }
    }

    goToPreviousPosition(firstPage) {
        if(!firstPage) {
            const previousPage = this.props.pageNumber - 1;
            this.callbackFunctionWithPage(previousPage);
        }
    }

    buildPages() {
        const { totalPages, visiblePages } = this.props;
        const currentPage = this.props.pageNumber;
        const currentGroup = Math.floor((currentPage - 1)/visiblePages) + 1;

        let pages = [];

        for( let page = 1; page + ((currentGroup - 1) * visiblePages) <= totalPages && page <= visiblePages; page++ ) {
            const numberPage = page + ((currentGroup - 1) * visiblePages);
            const isSelected = numberPage === currentPage;
            const newClass = classNames('pagination-buttons__button',
                {
                    'pagination-buttons__button--simple': !isSelected,
                    'pagination-buttons__button--selected': isSelected
                }
            );
            let button;

            if(!isSelected) {
                button = (
                    <div className={newClass} onClick={() => this.callbackFunctionWithPage(numberPage)}>
                        <span className="pagination-buttons__button--text">{formatWithoutRound(numberPage)}</span>
                    </div>
                );
            } else {
                button = (
                    <div className={newClass}>
                        <span className="pagination-buttons__button--text">{formatWithoutRound(numberPage)}</span>
                    </div>
                );
            }

            pages.push(
                <li>
                    {button}
                </li>
            );
        }

        return pages;
    }

    buildPagination() {
        const { totalPages, visiblePages, hasElipsis } = this.props;
        const currentPage = this.props.pageNumber;
        const lastGroup = Math.floor((totalPages - 1)/visiblePages) + 1;
        const currentGroup = Math.floor((currentPage - 1)/visiblePages) + 1;
        let pages = [];

        if(!hasElipsis || (lastGroup === currentGroup)) {
            pages = this.buildPages();
        } else if (hasElipsis) {
            pages = this.buildPages();

            pages.push(
                <li>
                    <div className="pagination-buttons__button pagination-buttons__button--elipsis">
                        <span className="pagination-buttons__button--text">...</span>
                    </div>
                </li>
            );

            pages.push(
                <li>
                    <div className="pagination-buttons__button pagination-buttons__button--simple" onClick={() => this.callbackFunctionWithPage(totalPages)}>
                        <span className="pagination-buttons__button--text">{formatWithoutRound(totalPages)}</span>
                    </div>
                </li>
            );
        }

        return (
            <ul className="pagination">
                {pages}
            </ul>
        );
    }

    render() {
        const { totalPages, iconFirst, iconPrevious, iconNext, iconBefore } = this.props;
        const currentPage = this.props.pageNumber;
        const firstPage = currentPage === 1;
        const lastPage = currentPage === totalPages;
        
        const disabledPrev = classNames({
            'pagination-buttons__button--simple': !firstPage,
            'pagination-buttons__button--disabled': firstPage 
        });
        const disabledNext = classNames({
            'pagination-buttons__button--simple': !lastPage,
            'pagination-buttons__button--disabled': lastPage 
        });
        
        const content = this.buildPagination();
        
        return(
            <div>
                <ul className="pager pagination-buttons__content">
                    <li>
                        <div className={`pagination-buttons__button ${disabledPrev}`} onClick={() => this.goToFirstPosition(firstPage)}>
                            <i className={`icon ${iconFirst} pagination-buttons__button--arrow`}></i>
                        </div>
                    </li>
                    <li>
                        <div className={`pagination-buttons__button ${disabledPrev}`} onClick={() => this.goToPreviousPosition(firstPage)}>
                            <i className={`icon ${iconPrevious} pagination-buttons__button--arrow`}></i>
                        </div>
                    </li>
                    {content}
                    <li>
                        <div className={`pagination-buttons__button ${disabledNext}`} onClick={() => this.goToNextPosition(lastPage)}>
                            <i className={`icon ${iconNext} pagination-buttons__button--arrow`}></i>
                        </div>
                    </li>
                    <li>
                        <div className={`pagination-buttons__button ${disabledNext}`} onClick={() => this.goToLastPosition(lastPage)}>
                            <i className={`icon ${iconBefore} pagination-buttons__button--arrow`}></i>
                        </div>
                    </li>
                </ul>
            </div>
        );
    }
}

PaginationButtons.propTypes = {
    totalPages: PropTypes.number.isRequired,
    callbackFunction: PropTypes.func.isRequired,
    pageNumber: PropTypes.number,
    hasElipsis: PropTypes.bool,
    visiblePages: PropTypes.number,
    iconFirst: PropTypes.string,
    iconPrevious: PropTypes.string,
    iconNext: PropTypes.string,
    iconBefore: PropTypes.string
};

PaginationButtons.defaultProps = {
    pageNumber: 1,
    visiblePages: 5,
    hasElipsis: true,
    iconFirst: "icon-anterior_doble",
    iconPrevious: "icon-anterior",
    iconNext: "icon-siguiente",
    iconBefore: "icon-siguiente_doble"
}

module.exports = PaginationButtons;
